export const NOTIFICATION_TITLES = {
  TEMPLATE_DRAFT_SAVED: "Template Draft Saved Successfully.",
} as const;

export const NOTIFICATION_FILTERS = {
  TEMPLATE_FILTERS: "ECP_TEMPLATE_BUILDER",
} as const;